import Vue from 'vue';
import Vuex from 'vuex';
// import router from '../router/index';

import authentication from './modules/authentication';
import users from './modules/users';
import merchants from './modules/merchants';
import roles from './modules/roles';
import permissions from './modules/permissions';
import systemVariables from './modules/systemVariables';
import form from './modules/form';
import options from './modules/options';
import auditTrails from './modules/auditTrails';
import external from './modules/external';

Vue.use(Vuex);

const vue = new Vue({
    name: 'store'
});

const store = new Vuex.Store({
    strict: true,
    state: {},
    mutations: {},
    actions: {
        clearState(context) {
            context.commit('authentication/CLEAR_STATE');
            context.commit('users/CLEAR_STATE');
        },
        error(context, payload) {
            // console.log(payload.response);

            // 200 = Success
            // 400 = Bad Request
            // 401 = Authorization Failed
            // 403 = Access Denied
            // 404 = Entity Not Found
            // 419 = Token Expired
            // 422 = Parameter Error
            // 500 = Server Error

            // const currentRouteName = router.currentRoute.name
            // && currentRouteName != 'register'
            if (payload.response && payload.response.status == 401) {
                vue.$eventBus.$emit('clear-data');
            }
        }
    },
    modules: {
        authentication,
        users,
        merchants,
        roles,
        permissions,
        systemVariables,
        form,
        options,
        auditTrails,
        external
    }
});

export default store;
